module.exports = __webpack_public_path__ + "img/betflix-support.55c1e77a.png";